import { render, staticRenderFns } from "./adsDetail.vue?vue&type=template&id=7f283ef7&scoped=true"
import script from "./adsDetail.vue?vue&type=script&lang=js"
export * from "./adsDetail.vue?vue&type=script&lang=js"
import style0 from "./adsDetail.vue?vue&type=style&index=0&id=7f283ef7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f283ef7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f283ef7')) {
      api.createRecord('7f283ef7', component.options)
    } else {
      api.reload('7f283ef7', component.options)
    }
    module.hot.accept("./adsDetail.vue?vue&type=template&id=7f283ef7&scoped=true", function () {
      api.rerender('7f283ef7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/adsManage/adsDetail.vue"
export default component.exports